var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 31.6667C7.10274 31.6667 0 24.564 0 15.8334C0 7.10274 7.10274 0 15.8334 0C24.564 0 31.6667 7.10274 31.6667 15.8334C31.6667 24.564 24.564 31.6667 15.8334 31.6667Z",
    fill: "#FE0050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 0V31.6667C24.564 31.6667 31.6667 24.564 31.6667 15.8334C31.6667 7.10274 24.564 0 15.8334 0Z",
    fill: "#E10555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 26.4096C10.0017 26.4096 5.25717 21.6651 5.25717 15.8334C5.25717 10.0017 10.0017 5.2572 15.8334 5.2572C21.6651 5.2572 26.4096 10.0017 26.4096 15.8334C26.4096 21.6651 21.6651 26.4096 15.8334 26.4096Z",
    fill: "#D9E7F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 5.2572V26.4096C21.6651 26.4096 26.4096 21.6651 26.4096 15.8334C26.4096 10.0017 21.6651 5.2572 15.8334 5.2572Z",
    fill: "#C8D4DF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 20.8432C13.071 20.8432 10.8236 18.5958 10.8236 15.8334C10.8236 13.071 13.071 10.8236 15.8334 10.8236C18.5958 10.8236 20.8432 13.071 20.8432 15.8334C20.8432 18.5958 18.5958 20.8432 15.8334 20.8432Z",
    fill: "#FE0050"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 10.8236V20.8432C18.5958 20.8432 20.8432 18.5958 20.8432 15.8334C20.8432 13.071 18.5958 10.8236 15.8334 10.8236Z",
    fill: "#E10555"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 16.7611C15.5959 16.7611 15.3584 16.6705 15.1774 16.4893C14.815 16.1271 14.815 15.5396 15.1774 15.1774L21.9999 8.35493C22.3621 7.99253 22.9496 7.99253 23.3118 8.35493C23.6742 8.71708 23.6742 9.30441 23.3118 9.66681L16.4893 16.4893C16.3084 16.6705 16.0709 16.7611 15.8334 16.7611Z",
    fill: "#2D2D55"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3118 8.35492L15.1774 16.4893C15.3584 16.6705 15.5959 16.7611 15.8334 16.7611C16.0709 16.7611 16.3084 16.6705 16.4893 16.4893L23.3118 9.6668C23.6742 9.30464 23.6742 8.71707 23.3118 8.35492Z",
    fill: "#0A0A48"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2859 10.2447C26.26 10.2447 26.2339 10.2435 26.2078 10.2416L22.5781 9.93545C22.1272 9.89728 21.7694 9.53972 21.7315 9.08889L21.4252 5.45888C21.4022 5.1866 21.5005 4.91819 21.6938 4.72491L25.6297 0.789032C25.8851 0.533663 26.2653 0.449587 26.6045 0.573769C26.9435 0.697708 27.1798 1.0072 27.2102 1.36694L27.4504 4.2161L30.2998 4.45649C30.6595 4.48693 30.969 4.72322 31.0932 5.06242C31.2171 5.40138 31.1331 5.78166 30.8777 6.03703L26.9418 9.9729C26.7671 10.1476 26.5308 10.2447 26.2859 10.2447Z",
    fill: "#FFC300"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2998 4.45652L27.4506 4.21613L21.9999 9.66682C22.1505 9.81734 22.3524 9.91639 22.5778 9.93548L26.2079 10.2416C26.2339 10.2435 26.2598 10.2447 26.2859 10.2447C26.5309 10.2447 26.7672 10.1476 26.9418 9.97293L30.8777 6.03705C31.1331 5.78168 31.2171 5.40141 31.0932 5.0622C30.969 4.72324 30.6595 4.48696 30.2998 4.45652Z",
    fill: "#FAB400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/Other.e412ce8b1cd8c9cab0449991c9c6d5d5.svg";
export { ForwardRef as ReactComponent };